/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import AlergiesScreen from '../../pages/mobile/sign-up/guest/take-health/AlergiesScreen';
import MedicalConditionScreen from '../../pages/mobile/sign-up/guest/take-health/MedicalConditionScreen';
import MedicationsScreen from '../../pages/mobile/sign-up/guest/take-health/MedicationsScreen';
import FamilyHistoryScreen from '../../pages/mobile/sign-up/guest/take-health/FamilyHistoryScreen';
import MeasurementsScreen from '../../pages/mobile/sign-up/guest/take-health/MeasurementsScreen';

const mobilesignUpTakeHealthScreeningRoutes = [
  {
    id: '1',
    path: '/sign-up/guest/take-health-screening/allergies',
    component: (props) => <AlergiesScreen {...props} />,
    props: {
      fieldName: 'allergies',
      step: 1,
      prevRoutePath: '/sign-up/guest/screening-request',
      nextRoutePath: '/sign-up/guest/take-health-screening/medical-condition',
    },
  },
  {
    id: '2',
    path: '/sign-up/guest/take-health-screening/medical-condition',
    component: (props) => <MedicalConditionScreen {...props} />,
    props: {
      fieldName: 'medical_conditions',
      step: 2,
      prevRoutePath: '/sign-up/guest/take-health-screening/allergies',
      nextRoutePath: '/sign-up/guest/take-health-screening/medications',
    },
  },
  {
    id: '3',
    path: '/sign-up/guest/take-health-screening/medications',
    component: (props) => <MedicationsScreen {...props} />,
    props: {
      fieldName: 'medications',
      step: 3,
      prevRoutePath: '/sign-up/guest/take-health-screening/medical-condition',
      nextRoutePath: '/sign-up/guest/take-health-screening/family-history',
    },
  },
  {
    id: '4',
    path: '/sign-up/guest/take-health-screening/family-history',
    component: (props) => <FamilyHistoryScreen {...props} />,
    props: {
      fieldName: 'family_history',
      step: 4,
      prevRoutePath: '/sign-up/guest/take-health-screening/medications',
      nextRoutePath: '/sign-up/guest/take-health-screening/measurements',
    },
  },
  {
    id: '5',
    path: '/sign-up/guest/take-health-screening/measurements',
    component: (props) => <MeasurementsScreen {...props} />,
    props: {
      fieldName: 'measurements',
      step: 5,
      prevRoutePath: '/sign-up/guest/take-health-screening/family-history',
      nextRoutePath: '',
      isLastQuestion: true,
    },
  },
];

export const getMobilesignUpTakeHealthScreeningRoutes = () => mobilesignUpTakeHealthScreeningRoutes;
